import { useEffect } from "react";
import { useGetAccountQuery } from "@/shared/services";
import { validateTimestampVisit } from "../utils";

export const useVisitTimestamps = () => {
  const { data: account, isSuccess } = useGetAccountQuery();
  useEffect(() => {
    if (isSuccess && account) {
      validateTimestampVisit(account);
    }
  }, [account, isSuccess]);
};
